var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Checkbox } from "@irati/ui/src/FormItem";
import Link from "@irati/ui/src/Link";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { TermsAndConditionsWrapper } from "./styled";
var TermsAndConditions = /** @class */ (function (_super) {
    __extends(TermsAndConditions, _super);
    function TermsAndConditions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TermsAndConditions.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, handleChange = _a.handleChange, value = _a.value, formatMessage = _a.formatMessage;
        var name = "tenantPaymentWalletTandC";
        return (React.createElement(TermsAndConditionsWrapper, null,
            React.createElement(Checkbox, { checked: isActive, name: name, onChange: handleChange, value: value }),
            React.createElement("label", { htmlFor: name },
                React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.termsAndConditions.firstSection" }),
                React.createElement(Link, { href: formatMessage({ id: "wallet.tenant.topUp.termsAndConditions.url" }), target: "_blank" },
                    React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.termsAndConditions.link" })),
                React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.termsAndConditions.secondSection" }))));
    };
    return TermsAndConditions;
}(PureComponent));
export default injectIntl(TermsAndConditions);
